import React from 'react';

/**
 * Renders the preloader
 */
const Loader = ({zIndex, text}) => {
    let style = {}
    if (zIndex !== undefined) {
        style = {zIndex: zIndex}
    }
    return (
        <div className="preloader" style={style}>
            <div className="status">
                <div className="bouncing-loader">
                    <div></div>
                    <div></div>
                    <div></div>
                </div>
                <div className="text-loader">
                    {text}
                </div>
            </div>
        </div>
    );
};

export default Loader;
